var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_punchCriteriaType_list_title"),
      pad: "0",
      addBtn: _vm.hasBtn("add-admin-clock-in-criteria"),
    },
    on: {
      new: function ($event) {
        _vm.mapToDialog = true
      },
    },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Tabler", {
              attrs: {
                headers: _vm.headers,
                items: _vm.desserts,
                showSelect: _vm.showSelect,
                height: _vm.$vuetify.breakpoint.height - 275,
                totalCount: _vm.totalCount,
              },
              on: {
                change: function (page, perpage, callback) {
                  _vm.getList(page, perpage, callback)
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "item.icon",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      item.attachments.length
                        ? _c("v-img", {
                            staticClass: "grey lighten-2 ma-2 ml-0 pl-0",
                            attrs: {
                              src: item.attachments[0]["url"],
                              "aspect-ratio": "1",
                              "max-width": "60",
                              "max-height": "60",
                            },
                          })
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: "item.name",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("div", { staticClass: "balck--text table-title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$getCommonLangValue(item.criteria_type_name)
                            ) +
                            " "
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "text--secondary table-subtitle" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$getCommonLangValue(
                                  item.criteria_type_description
                                )
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: "item.abbr",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _vm._v(
                        _vm._s(_vm.$getCommonLangValue(item.criteria_type_abbr))
                      ),
                    ]
                  },
                },
                {
                  key: "item.action",
                  fn: function (ref) {
                    var item = ref.item
                    return [
                      _c("tableListTools", {
                        attrs: {
                          uuid: item.uuid,
                          delBtn: _vm.hasBtn("delete-admin-clock-in-criteria"),
                          editBtn: _vm.hasBtn("edit-admin-clock-in-criteria"),
                          editText:
                            "message_essweb_list_components_tools_editBtnTip",
                          viewBtn: _vm.hasBtn("view-admin-clock-in-criteria"),
                          title: _vm.$t(
                            "label_essweb_punchCriteriaType_list_title"
                          ),
                        },
                        on: {
                          delete: _vm.toDelete,
                          edit: _vm.toEdit,
                          view: _vm.toView,
                        },
                      }),
                    ]
                  },
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newMappingDialog", {
              attrs: { show: _vm.mapToDialog, on: "" },
              on: {
                onNewProperty: _vm.onNew,
                close: function ($event) {
                  _vm.mapToDialog = false
                },
              },
            }),
            _c("editMappingDialog", {
              attrs: {
                show: _vm.mapToEditDialog,
                showAction: _vm.showAction,
                CurDataUuid: _vm.CurDataUuid,
              },
              on: {
                onEditProperty: _vm.onEdit,
                close: function ($event) {
                  _vm.mapToEditDialog = false
                  _vm.CurDataUuid = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }